import React from "react";
import { Link } from "react-router-dom";
import {
    Box,
    Container,
    Typography,
    Button,
    IconButton
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import RedditIcon from "@mui/icons-material/Reddit";
import YouTubeIcon from "@mui/icons-material/YouTube";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                background: "linear-gradient(135deg, #2E8B57 0%, #228B22 100%)",
                color: "white",
                py: { xs: 6, md: 8 },
                mt: "auto",
            }}
        >
            <Container maxWidth="lg">
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 3,
                    }}
                >
                    {/* Left section */}
                    <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
                        <Typography
                            variant="body2"
                            sx={{ opacity: 0.9, fontSize: "0.875rem" }}
                        >
                            © 2026 Quran Chat Buddy. All rights reserved.
                        </Typography>
                        <Typography
                            variant="caption"
                            sx={{
                                opacity: 0.7,
                                fontSize: "0.75rem",
                                mt: 0.5,
                                display: "block",
                            }}
                        >
                            Built with ❤️ for the Muslim community
                        </Typography>
                    </Box>

                    {/* Center links */}
                    <Box
                        sx={{
                            display: "flex",
                            gap: { xs: 1.5, sm: 2 },
                            flexWrap: "wrap",
                            justifyContent: "center",
                            maxWidth: 720,
                        }}
                    >
                        <Button component={Link} to="/blogs" size="small" sx={linkStyle}>
                            Islamic Blogs
                        </Button>
                        <Button
                            component={Link}
                            to="/quran-pdf-download"
                            size="small"
                            sx={linkStyle}
                        >
                            Quran PDF
                        </Button>
                        <Button
                            component={Link}
                            to="/surah-yaseen"
                            size="small"
                            sx={linkStyle}
                        >
                            Surah Yaseen
                        </Button>
                        <Button component={Link} to="/news" size="small" sx={linkStyle}>
                            News
                        </Button>
                        <Button
                            component={Link}
                            to="/deenbuddy"
                            size="small"
                            sx={linkStyle}
                        >
                            App
                        </Button>
                        <Button
                            component={Link}
                            to="/terms-of-service"
                            size="small"
                            sx={linkStyle}
                        >
                            Terms
                        </Button>
                        <Button
                            component="a"
                            href="/privacy-policy"
                            size="small"
                            sx={linkStyle}
                        >
                            Privacy
                        </Button>
                        <Button
                            component="a"
                            href="/data-deletion"
                            size="small"
                            sx={linkStyle}
                        >
                            Data Deletion
                        </Button>
                        <Button component={Link} to="/contact" size="small" sx={linkStyle}>
                            Contact
                        </Button>
                    </Box>

                    {/* Social icons */}
                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                            justifyContent: "center",
                        }}
                    >
                           <IconButton
                            href="https://www.instagram.com/quranchatbuddy/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={iconStyle}
                        >
                            <InstagramIcon />
                        </IconButton>
                        <IconButton
                            href="https://www.facebook.com/profile.php?id=61581826653983"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={iconStyle}
                        >
                            <FacebookIcon />
                        </IconButton>
                        <IconButton
                            href="https://x.com/Quranchatbuddy"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={iconStyle}
                        >
                            <TwitterIcon />
                        </IconButton>
                        <IconButton
                            href="https://www.reddit.com/user/Adventurous_Feed2394/"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={iconStyle}
                        >
                            <RedditIcon />
                        </IconButton>
                        <IconButton
                            href="https://www.youtube.com/@meccatimequranchatbuddy"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={iconStyle}
                        >
                            <YouTubeIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

const linkStyle = {
    color: "white",
    textTransform: "none",
    opacity: 0.9,
    fontSize: "0.875rem",
    minWidth: "auto",
    p: 1,
    "&:hover": {
        opacity: 1,
        bgcolor: "rgba(255, 255, 255, 0.1)",
    },
};

const iconStyle = {
    color: "white",
    opacity: 0.85,
    "&:hover": {
        opacity: 1,
        bgcolor: "rgba(255, 255, 255, 0.15)",
    },
};

export default Footer;
